/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import { useMemo } from 'preact/hooks';
import { Container } from '@adobe-commerce/elsie/lib';
import { SkeletonLoaderProps } from '@/auth/types';
import {
  SignUpSkeleton,
  SignInSkeleton,
  ResetPasswordSkeleton,
} from './Skeletons';

export const SkeletonLoader: Container<SkeletonLoaderProps> = ({
  activeSkeleton,
}) => {
  const renderSkeleton = useMemo(
    () => ({
      signInForm: <SignInSkeleton />,
      signUpForm: <SignUpSkeleton />,
      resetPasswordForm: <ResetPasswordSkeleton />,
    }),
    []
  );

  return <>{renderSkeleton[activeSkeleton]}</>;
};
